import { render, staticRenderFns } from "./CreateInscripcionCK.vue?vue&type=template&id=5944c8d2"
import script from "./CreateInscripcionCK.vue?vue&type=script&lang=js"
export * from "./CreateInscripcionCK.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports